import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import { useLang, LangToggle } from '../LanguageContext';
import { t } from '../i18n';

export default function Login({ onLogin }) {
  const { lang, isRTL } = useLang();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async () => {
    if (!email || !password) return;
    setLoading(true);
    setError('');
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const userDoc = await getDoc(doc(db, 'users', cred.user.uid));
      if (userDoc.exists()) {
        onLogin({ uid: cred.user.uid, ...userDoc.data() });
      }
    } catch (e) {
      setError(t(lang, 'login_error'));
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(160deg, #1C2833 0%, #2C3E50 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif', direction: isRTL ? 'rtl' : 'ltr' }}>
      
      {/* Bouton langue */}
      <div style={{ position: 'absolute', top: 20, right: isRTL ? 'auto' : 20, left: isRTL ? 20 : 'auto' }}>
        <LangToggle />
      </div>

      <div style={{ width: '100%', maxWidth: 380, padding: '0 24px' }}>
        {/* LOGO */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🎨</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#fff', letterSpacing: -0.5 }}>KDPeinture</div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginTop: 6 }}>{t(lang, 'login_subtitle')}</div>
        </div>

        {/* CARTE */}
        <div style={{ background: '#fff', borderRadius: 16, padding: '28px 24px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#1C2833', marginBottom: 22, textAlign: isRTL ? 'right' : 'left' }}>{t(lang, 'login_title')}</div>

          {error && (
            <div style={{ background: '#FCEBEB', border: '1px solid #f5c6c6', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#A32D2D', marginBottom: 16, textAlign: isRTL ? 'right' : 'left' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 6, textAlign: isRTL ? 'right' : 'left' }}>{t(lang, 'email')}</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="email@exemple.com"
              style={{ width: '100%', padding: '11px 14px', border: '1px solid #ddd', borderRadius: 10, fontSize: 14, fontFamily: 'system-ui', boxSizing: 'border-box', textAlign: isRTL ? 'right' : 'left' }}
            />
          </div>

          <div style={{ marginBottom: 22 }}>
            <label style={{ fontSize: 12, color: '#555', display: 'block', marginBottom: 6, textAlign: isRTL ? 'right' : 'left' }}>{t(lang, 'password')}</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              style={{ width: '100%', padding: '11px 14px', border: '1px solid #ddd', borderRadius: 10, fontSize: 14, fontFamily: 'system-ui', boxSizing: 'border-box', textAlign: isRTL ? 'right' : 'left' }}
            />
          </div>

          <button
            onClick={handleLogin}
            disabled={loading}
            style={{ width: '100%', padding: '13px', background: '#C0392B', border: 'none', borderRadius: 10, color: '#fff', fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? t(lang, 'login_loading') : t(lang, 'login_btn')}
          </button>
        </div>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 11, color: 'rgba(255,255,255,0.3)' }}>
          Activiter Commercial v21 · KDPeinture © 2026
        </div>
      </div>
    </div>
  );
}
